import AddAdminModal from './AddAdminModal';

export default AddAdminModal;
